import { apiRequestToken } from '../Utilidades/apiRequest';
import { ContenidoDinamicoProps } from '../interfaces/contenidodinamicoInterfaces';

export const getContenidoDinamico = async (tipo: String) => {
    return apiRequestToken({
        endpoint: `contenidodinamico?tipo=${tipo}`,
        token: false,
        method: 'GET',
    })
};
export const postContenidoDinamico = async (contenidodinamico: ContenidoDinamicoProps) => {
    return apiRequestToken({
        endpoint: 'contenidodinamico',
        body: contenidodinamico,
        method: 'POST',
    })
};